class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.label = this.querySelector('.field__label');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      // Immediate updates for label visibility
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.input.addEventListener('input', this.updateLabelVisibility.bind(this));

      // Initialize label visibility on load
      this.updateLabelVisibility();
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
    this.updateLabelVisibility();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.updateLabelVisibility();
    }
  }

  onInputFocus() {
    // Hide label when focusing the input
    this.hideLabel();
  }

  onInputBlur() {
    // Keep label hidden if input has value; show if empty
    this.updateLabelVisibility();
  }

  updateLabelVisibility() {
    if (!this.label || !this.input) return;
    const hasValue = this.input.value && this.input.value.trim().length > 0;
    const isFocused = document.activeElement === this.input;
    if (isFocused || hasValue) {
      this.hideLabel();
    } else {
      this.showLabel();
    }
  }

  hideLabel() {
    if (!this.label) return;
    this.label.style.setProperty('display', 'none', 'important');
  }

  showLabel() {
    if (!this.label) return;
    this.label.style.removeProperty('display');
  }
}

customElements.define('search-form', SearchForm);
